import React from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from 'src/components/ui/table';
import { Client } from '../types/client.types';
import ClientManagementTableRow from './client-management-table-row';

interface ClientManagementTableProps {
  clients: Client[];
  className?: string;
  isCreation?: boolean;
}

const ClientManagementTable: React.FC<ClientManagementTableProps> = ({
  className,
  clients,
  isCreation,
}) => {
  return (
    <div className={`w-full ${className} overflow-visible`}>
      <Table className='overflow-visible'>
        <TableHeader className="sticky top-0 bg-white z-10 rounded-t-lg">
          <TableRow className="border-b border-gray-201 rounded-t-lg">
            <TableHead className='w-[3%] min-w-[30px] py-1.5' />
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Client
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[20%] min-w-[150px]">
              Users
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[20%] min-w-[150px]">
              Accounts
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Campaigns
            </TableHead>
            <TableHead className="text-gray-600 py-1.5 w-[30%] min-w-[200px]">
              Details
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="rounded-lg overflow-visible">
          {clients.map((client) => (
            <ClientManagementTableRow
              key={client.ext_client_id}
              client={client}
              isCreation={isCreation}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ClientManagementTable;
